import React from 'react';
import LoadingIcon from "../Chat/common/LoadingIcon";
import styles from './LoadingScreen.module.scss';
function LoadingScreen({ style }) {
    return (React.createElement("div", { className: styles.container, style: style },
        React.createElement(LoadingIcon, null)));
}
export default LoadingScreen;
